import React, { useEffect, useState } from "react";

import { Dispatch } from "redux";
import { connect } from "react-redux";
import { SelectorNames } from "@goaigua/go-components";

import { setLanguage } from "redux/reducers/preferences/actions";

import { OptionsType } from "types/generic/index";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobeAmericas } from "@fortawesome/pro-light-svg-icons";
import { useIntl } from "react-intl";
import { AVAILABLE_LANGUAGES, getEnvVariable } from "utils/environment";

type RegionType = {
    language: string;
    updateLanguage: (language: string) => void;
    region: { language: string };
    setRegion: React.Dispatch<
        React.SetStateAction<{
            language: string;
        }>
    >;
    setIsBtnActive: React.Dispatch<React.SetStateAction<boolean>>;
};

const availableLanguages = getEnvVariable(AVAILABLE_LANGUAGES).split(",");

const RegionParameterContent = ({
    region,
    setRegion,
    setIsBtnActive,
}: RegionType) => {
    const intl = useIntl();

    const [optionLanguageDropdown, setOptionLanguageDropdown] = useState<
        OptionsType[]
    >(
        availableLanguages.map((language, id) => ({
            id,
            description: intl.formatMessage({
                id: `app.Language.${language ? language : "en"}`,
            }),
            selected: id === 0 ? true : false,
            value: language,
        }))
    );

    const [optionUnitSystemDropdown, setOptionUnitSystemDropdown] = useState<
        OptionsType[]
    >([
        {
            id: 0,
            description: intl.formatMessage({
                id: "app.components.preferences.internationalSystem",
            }),
            selected: false,
            value: "international",
        },
        {
            id: 1,
            description: intl.formatMessage({
                id: "app.components.preferences.decimalMetricSystem",
            }),
            selected: false,
            value: "metric",
        },
    ]);

    useEffect(() => {
        changeLanguageValue();
    }, [region.language]);

    const changeLanguageValue = () => {
        const optionLanguageDropdownAux = optionLanguageDropdown.slice();

        const optionTrueToFalseIndex = optionLanguageDropdownAux.findIndex(
            (option) => option.selected === true
        );

        optionLanguageDropdownAux[optionTrueToFalseIndex] = {
            ...optionLanguageDropdownAux[optionTrueToFalseIndex],
            selected: false,
        };

        const optionFalseToTrueIndex = optionLanguageDropdownAux.findIndex(
            (option) => option.value === region.language
        );

        optionLanguageDropdownAux[optionFalseToTrueIndex] = {
            ...optionLanguageDropdownAux[optionFalseToTrueIndex],
            selected: true,
        };

        setOptionLanguageDropdown(optionLanguageDropdownAux);
    };

    const changeUnitSystemValue = () => {
        const optionUnitSystemDropdownAux = optionUnitSystemDropdown.slice();

        const optionTrueToFalseIndex = optionUnitSystemDropdownAux.findIndex(
            (option) => option.selected === true
        );

        optionUnitSystemDropdownAux[optionTrueToFalseIndex] = {
            ...optionUnitSystemDropdownAux[optionTrueToFalseIndex],
            selected: false,
        };

        setOptionUnitSystemDropdown(optionUnitSystemDropdownAux);
    };

    return (
        <>
            <div className="c-body">
                <span>
                    <FontAwesomeIcon icon={faGlobeAmericas} />
                </span>
                <span className="c-body__title c-body__title--text">
                    {intl.formatMessage({
                        id: "app.components.preferences.regionParameters",
                    })}
                </span>
                <span className="o-divider-line"></span>
            </div>
            <div className="c-body__container">
                <div className="c-body__dropdown">
                    <SelectorNames
                        items={optionLanguageDropdown}
                        search={false}
                        locale={""}
                        label={intl.formatMessage({ id: "app.Language" })}
                        onChangeItems={function (items: any): void {
                            setRegion({ ...region, language: items.value });
                            setIsBtnActive(true);
                        }}
                        size="l"
                    />
                </div>
            </div>
        </>
    );
};

const mapStateToProps = (state: any) => {
    return {
        language: state.preferences.region.language,
    };
};
const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        updateLanguage: (language: string) => dispatch(setLanguage(language)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RegionParameterContent);
